var _g, _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWeatherWidgetSunCloud(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    viewBox: "0 0 212 201",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipRule: "evenodd",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m45.928 80.161c0-33.177 26.895-60.071 60.072-60.071 33.176 0 60.071 26.894 60.071 60.071 0 33.176-26.895 60.071-60.071 60.071-33.177 0-60.072-26.895-60.072-60.071zm-5.1457 9.1008-10.841 20.925 21.99 8.475 0.1272 23.568 23.41-2.715 11.065 20.808 19.466-13.283 19.467 13.283 11.063-20.808 23.41 2.715 0.127-23.568 21.99-8.475-10.839-20.925 15.532-17.725-19.322-13.492 5.517-22.911-23.38-2.9663-5.763-22.852-22.08 8.2392-15.722-17.555-15.723 17.555-22.079-8.2392-5.763 22.852-23.379 2.9663 5.5154 22.911-19.323 13.492 15.534 17.725z",
    fill: "#F0A64D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m106 26.737c29.505 0 53.424 23.919 53.424 53.424 0 29.505-23.919 53.424-53.424 53.424-29.505 0-53.424-23.919-53.424-53.424 0-29.505 23.919-53.424 53.424-53.424z",
    fill: "#F0A64D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m166.07 80.161c0-33.177-26.896-60.071-60.071-60.071v-20.091l15.722 17.555 22.08-8.2392 5.763 22.852 23.38 2.9663-5.518 22.911 19.323 13.492-15.532 17.725 10.839 20.925-21.99 8.475-0.127 23.568-23.41-2.715-11.063 20.808-19.467-13.283v-6.808c33.175 0 60.071-26.895 60.071-60.071z",
    fill: "#EB8C3C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m159.42 80.161c0 29.505-23.919 53.424-53.424 53.424v-106.85c29.505 0 53.424 23.919 53.424 53.424z",
    fill: "#EB8C3C"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m182.77 117v1.5h1.52c14.411 0 26.208 11.798 26.208 26.208 0 14.412-11.797 26.207-26.208 26.207h-38.396v1.5c0 14.412-11.797 26.208-26.208 26.208h-64.068c-14.41 0-26.208-11.796-26.208-26.208v-1.5h-1.7052c-14.412 0-26.208-11.795-26.208-26.207 0-14.41 11.796-26.208 26.208-26.208h38.583v-1.5c0-14.41 11.796-26.207 26.208-26.207h64.067c14.41 0 26.207 11.797 26.207 26.207z",
    fill: "#FFFFFE",
    stroke: "#DBDCD6",
    strokeWidth: 3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m184.29 117h-0.02c0-15.238-12.469-27.707-27.707-27.707h-50.565v110.83h13.688c15.239 0 27.708-12.467 27.708-27.708h36.896c15.239 0 27.708-12.467 27.708-27.707 0-15.239-12.469-27.708-27.708-27.708z",
    clipRule: "evenodd",
    fill: "#DBDCD6",
    fillRule: "evenodd"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWeatherWidgetSunCloud);
export default __webpack_public_path__ + "static/media/weather-widget_sun-cloud.db54ce0e.svg";
export { ForwardRef as ReactComponent };